import { createFileRoute } from '@tanstack/react-router'
import { ReleaseNotesPage } from '@/components/ReleaseNotes/ReleaseNotesPage'
import { useAuth } from '@/hooks/useAuth'
import { LoginRequiredEmptyState } from '@/components/EmptyStates/LoginRequiredEmptyState'

function UpdatesPage() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <LoginRequiredEmptyState />
    )
  }

  return <ReleaseNotesPage />
}

export const Route = createFileRoute('/updates/')({
  component: UpdatesPage,
})
